export default __webpack_public_path__ + "static/englet-1-0ca034454b488d41469fc3c0a789024a.jpg";